(function() {
  var ConfirmDialog, Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ConfirmDialog = App.loadClass('core::ConfirmDialog');

  Controller = App.loadClass('core::Angular/Controller');

  exports.DaystoharvestController = (function(superClass) {
    extend(DaystoharvestController, superClass);

    function DaystoharvestController(scope, transitions, days1, repo, loader) {
      var ref, ref1;
      this.scope = scope;
      this.transitions = transitions;
      this.days = days1;
      this.repo = repo;
      this.loader = loader;
      this.excel = bind(this.excel, this);
      this.save = bind(this.save, this);
      this.handleDaysToHarvest = bind(this.handleDaysToHarvest, this);
      DaystoharvestController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.title = 'Days to Harvest';
      this.scope.fullpage = true;
      this.scope.absolute_errors = true;
      this.scope.resizeTable = 0;
      this.scope.excel = this.excel;
      this.scope.save = this.save;
      if ((ref = App.sidebar) != null) {
        ref.close();
      }
      if ((ref1 = App.angularSidebar) != null) {
        ref1.close();
      }
      this.handleDaysToHarvest();
    }


    /*
    Handle the preloaded data
    We have to preload via resolve in the router b/c Handsontables
    does weird things when you try to load the data after initiation
     */

    DaystoharvestController.prototype.handleDaysToHarvest = function() {
      var id;
      this.scope.setAlert(this.days.status);
      if (this.days.status.type === 'success') {
        this.days = this.days.data;
        this.raw_days = $.map(this.days.dth, function(value, index) {
          return [value];
        });
        return this.scope.table_settings = {
          currentRowClassName: 'highlighted',
          currentColClassName: 'highlighted',
          data: this.raw_days,
          columns: (function() {
            var i, len, ref, results;
            ref = this.days.hybridIds;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              id = ref[i];
              results.push({
                data: 'hybrid' + id + '.dth'
              });
            }
            return results;
          }).call(this),
          rowHeaders: this.days.rowHeaders,
          colHeaders: this.days.colHeaders,
          maxRows: this.days.rowHeaders.length,
          maxCols: this.days.colHeaders.length,
          beforeChange: function(changes, source) {
            var cell, col, i, len;
            for (i = 0, len = changes.length; i < len; i++) {
              cell = changes[i];
              if (isNaN(parseFloat(cell[3])) || parseFloat(cell[3]) % 1 !== 0 || parseInt(cell[3]) < 0 || parseInt(cell[3]) > 200) {
                return false;
              } else {
                if ((parseFloat(cell[3]) === -0) || (parseFloat(cell[3]) === +0)) {
                  cell[3] = 0;
                }
                col = cell[1].match(/.*[^.dth]/);
                this.getSourceDataAtRow(cell[0])[col[0]].changed = true;
              }
            }
            return true;
          }
        };
      }
    };


    /*
    Save days to harvest
     */

    DaystoharvestController.prototype.save = function() {
      var cell, changedData, days, i, key, len, ref, row;
      this.scope.setAlert({
        msg: 'Saving Days...',
        type: 'info'
      });
      changedData = [];
      ref = this.raw_days;
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        for (key in row) {
          cell = row[key];
          if (cell.changed === true) {
            changedData.push(cell);
          }
        }
      }
      days = JSON.stringify(changedData);
      return this.repo.save(days).then((function(_this) {
        return function(response) {
          var jsr;
          jsr = response.data;
          return _this.scope.setAlert(jsr.status);
        };
      })(this));
    };


    /*
    Excel export
     */

    DaystoharvestController.prototype.excel = function() {
      return this.repo.excel();
    };

    return DaystoharvestController;

  })(Controller);

}).call(this);
